export const HOST = import.meta.env.VITE_API_HOST;

export const LOGIN = '/login';
export const GET_USER = '/me';
